import { Modal } from "antd";

const ConfirmationModal = ({
  isModalOpen = false,
  title = "Confirmation Modal",
  description = "",
  confirmationAction = () => {},
  setIsModalOpen = () => {}
}) => {
  return (
    <Modal
      title={title}
      centered
      open={isModalOpen}
      onOk={() => {
        confirmationAction();
        setIsModalOpen(false);
      }}
      onCancel={() => setIsModalOpen(false)}
    >
      {description}
    </Modal>
  );
};

export default ConfirmationModal;
